import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import ConfigValuePicker from '../picker/ConfigValuePicker'

const ConfigValuesFilter = ({ field, ...props }) => {
  const { t } = useTranslation('serviceOrders')
  field = field || 'semaphoreKeys'
  const label = t('filters.semaphore')
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <div>
      <ConfigValuePicker value={value} onChange={handleChange(field)} multiple label={label} {...props} />
    </div>
  )
}

export default ConfigValuesFilter
